import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import type { RfqBucket } from "../types";
import { DEFAULT_BUCKET, isRfqBucket } from "../constants/buckets";

export function useRfqBucketParam() {
  const [searchParams, setSearchParams] = useSearchParams();
  const status = searchParams.get("status");
  const bucket: RfqBucket = isRfqBucket(status) ? status : DEFAULT_BUCKET;
  const page = Math.max(1, parseInt(searchParams.get("page") ?? "1", 10) || 1);

  const selectBucket = useCallback(
    (next: RfqBucket) => {
      setSearchParams((prev) => {
        prev.set("status", next);
        prev.delete("page");
        return prev;
      });
    },
    [setSearchParams],
  );

  const setPage = useCallback(
    (next: number, options?: { replace?: boolean }) => {
      setSearchParams(
        (prev) => {
          prev.set("page", String(next));
          return prev;
        },
        { replace: options?.replace },
      );
    },
    [setSearchParams],
  );

  return { bucket, page, selectBucket, setPage };
}
